export enum TrailerSize {
  STRAIGHT_TRUCK = 'straight-truck',
  VAN = 'van',
}
